export default "__VITE_ASSET__BsEENT5e__"